import React from 'react';
import {Grid, Select, MenuItem, InputLabel,FormControl,} from '@material-ui/core'
import IntlMessages from 'util/IntlMessages';
import { isUndefined } from 'lodash';
import {useSelector} from 'react-redux'
function OrderVardeSetting(props) {
    const Flags = useSelector(state=>state.accountsData.Flags)
    console.log(props.abonnamangeSetting,"props.orderVardeSetting")
    return (
      <Grid item xs="12">
          <FormControl variant='outlined' fullWidth size='small'>
            <InputLabel id="demo-simple-select-label"><IntlMessages id="Contract.Invoicing"/></InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Intervall"
                value={isUndefined(props.abonnamangeSetting)?Flags.AbonemangeStandard:props.abonnamangeSetting}
                onChange={(e) => props.setAbonnamangeSetting(e.target.value)}
              >
                <MenuItem value={1}><IntlMessages id="Table.Price.Utpris"/></MenuItem>
                <MenuItem value={0}><IntlMessages id="Table.Price.TB"/></MenuItem>
              </Select>
            </FormControl>
          </Grid>
    );
}

export default OrderVardeSetting;